/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { Gnoment } from 'shared-ui/gnoment';

export const permitSeasonInfoProps = PropTypes.shape({
    lotteryDisplayDate: PropTypes.instanceOf(Gnoment),
    lotteryReleaseDate: PropTypes.instanceOf(Gnoment),
    lotterySeasonEnd: PropTypes.instanceOf(Gnoment),
    lotterySeasonStart: PropTypes.instanceOf(Gnoment),
    seasonEnd: PropTypes.instanceOf(Gnoment),
    seasonStart: PropTypes.instanceOf(Gnoment),
});

export const availabilityProps = PropTypes.shape({
    bools: PropTypes.object, // { 2019-05-21: <bool>, 2019-05-22: <bool>, etc.. }
    nums: PropTypes.object, // { 2019-05-21: <number>, 2019-05-22: <number>, etc.. }
    quota_type_maps: PropTypes.object, // { QuotaUsageByMember: { 2019-05-21T00:00:00Z: remaining: <number>, show_walkup: <bool>, total: <number> } }
});
